export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-9-f8f471df22e7f47a083973334cf612b6.png";